export var DataCatalogTreeItemType;
(function (DataCatalogTreeItemType) {
    DataCatalogTreeItemType["DATA_CATALOG_TREE_ITEM_TYPE_UNSPECIFIED"] = "DATA_CATALOG_TREE_ITEM_TYPE_UNSPECIFIED";
    DataCatalogTreeItemType["DATA_CATALOG_TREE_ITEM_TYPE_NAMESPACE"] = "NAMESPACE";
    DataCatalogTreeItemType["DATA_CATALOG_TREE_ITEM_TYPE_DATASET"] = "DATASET";
})(DataCatalogTreeItemType || (DataCatalogTreeItemType = {}));
